import { types as t, Instance, SnapshotOut } from 'mobx-state-tree';
import model from './model';
import actions from './actions';
import views from './views';
export type { AssetLink, AssetEntry } from './views';

export const ReportModel = model.views(views).actions(actions);

export interface IReport extends Instance<typeof ReportModel> {}
export interface IReportOut extends SnapshotOut<typeof ReportModel> {}

export default t.snapshotProcessor(ReportModel, {
  preProcessor(values) {
    const result = { ...values };
    result.configuration = {
      ...(values.configuration || {}),
      run_type: values.run_type
    };
    return result;
  }
});
